import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import randomstring from 'uuid/v4';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select'

import Close from '@material-ui/icons/Close';;

class Filter extends React.Component {
    state = {
        estado: this.props.filtro && this.props.filtro.estado,
        local: this.props.filtro && this.props.filtro.local,
        desde: this.props.filtro && this.props.filtro.desde,
        hasta: this.props.filtro && this.props.filtro.hasta,
    };

    handleRemoveDate = (nombre) => (event) => {
        this.setState({ [nombre]: '' });
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleClose = (estado, local, desde, hasta) => (event) => {
        if (!estado && !desde && !hasta && !local) {
            this.props.handleClose(undefined);
        } else {
            this.props.handleClose({
                estado: estado,
                desde: desde,
                hasta: hasta,
                local: local,
            });
        }
    };

    render() {
        const { estado, local, desde, hasta } = this.state;
        const { intl, info } = this.props;
        const nodes = info.security.locals.reduce((arr, c) => {
            if (info.security.localPermits[c.id] && info.security.localPermits[c.id].length > 0) {
                arr.push(c);
            }
            return arr;
        }, []);
        return (
            <Dialog
                open={true}
                onClose={this.handleClose(null, null, null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent className={'padding_borders'}>
                    <div className="flex_full_row margin_top_18 align_center">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'production_table_status' })}
                            </InputLabel>
                            <Select
                                native
                                value={estado}
                                onChange={this.handleChange}
                                inputProps={{ name: 'estado', id: 'estado-id' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                <option key={randomstring()} value={1}>
                                    {intl.formatMessage({
                                        id: 'production_table_production_accepted',
                                    })}
                                </option>
                                {/* 
                                <option key={randomstring()} value={2}>
                                    {intl.formatMessage({
                                        id: 'production_table_production_rejected',
                                    })}
                                </option>
                                */}
                                <option key={randomstring()} value={3}>
                                    {intl.formatMessage({
                                        id: 'production_table_production_expired',
                                    })}
                                </option>
                                <option key={randomstring()} value={4}>
                                    {intl.formatMessage({
                                        id: 'production_table_production_pending',
                                    })}
                                </option>
                            </Select>
                        </FormControl>
                    </div>
                    <div className="flex_full_row margin_top_32 align_center">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'type_label_local' })}
                            </InputLabel>
                            <Select
                                native
                                value={local}
                                onChange={this.handleChange}
                                inputProps={{ name: 'local', id: 'local-id' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                {nodes &&
                                    nodes.map((cat) => {
                                        return (
                                            <option key={randomstring()} value={cat.id}>
                                                {cat.name}
                                            </option>
                                        );
                                    })}
                            </Select>
                        </FormControl>
                    </div>
                    <div className="flex_full_row margin_top_32 align_center">
                        <TextField
                            fullWidth
                            name={'desde'}
                            id={'desde'}
                            label={intl.formatMessage({ id: 'form_field_add_date_init_label' })}
                            type="date"
                            value={desde ? desde : ''}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                        <Close
                            className="c_lipstick hand"
                            onClick={this.handleRemoveDate('desde')}
                        />
                    </div>
                    <div className="flex_full_row margin_top_32 align_center">
                        <TextField
                            fullWidth
                            name={'hasta'}
                            id={'hasta'}
                            label={intl.formatMessage({ id: 'form_field_add_date_end_label' })}
                            type="date"
                            value={hasta ? hasta : ''}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                        <Close
                            className="c_lipstick hand"
                            onClick={this.handleRemoveDate('hasta')}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose()} color="primary">
                        <FormattedMessage id="remove" />
                    </Button>
                    <Button
                        onClick={this.handleClose(estado, local, desde, hasta)}
                        color="primary"
                        autoFocus
                    >
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

Filter.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Filter);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/forecasts/FilterMenu.js